import {ReactNode, useCallback, useState} from 'react'
import {User} from '../common/spotify'
import {LoginModal} from '../components/LoginModal'
import {useSpotifyAuth} from './useSpotifyAuth'

export const useLoginPrompt = () => {
  const [authState] = useSpotifyAuth()
  const [open, setOpenPrompt] = useState(false)

  const Prompt = useCallback(
    ({
      children
    }: {
      children?: ReactNode | ((auth: User) => ReactNode)
    }): JSX.Element | null => {
      if (!open) {
        return null
      }
      return authState?.authenticated ? (
        typeof children === 'function' ? (
          children(authState.user)
        ) : (
          children ?? null
        )
      ) : (
        <LoginModal onClose={() => setOpenPrompt(false)} />
      )
    },
    [authState, open]
  )

  const openPrompt = useCallback(() => {
    setOpenPrompt(true)
  }, [])

  const closePrompt = useCallback(() => {
    setOpenPrompt(false)
  }, [])

  return [openPrompt, Prompt, closePrompt] as const
}
